import { render, staticRenderFns } from "./nav-tabs.vue?vue&type=template&id=0b558e2f&scoped=true&"
import script from "./nav-tabs.vue?vue&type=script&lang=js&"
export * from "./nav-tabs.vue?vue&type=script&lang=js&"
import style0 from "./nav-tabs.vue?vue&type=style&index=0&id=0b558e2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b558e2f",
  null
  
)

component.options.__file = "nav-tabs.vue"
export default component.exports